
import {Component, Prop, Mixins, Watch} from "vue-property-decorator";
import ProtestoIhtar from "@/components/forms/ProtestoIhtarForm.vue";
import IlamBilgileriForm from "@/components/forms/alacak/IlamBilgileriForm.vue";
import TasinirBilgisiForm from "@/components/forms/TasinirBilgisiForm.vue";
import TasinmazBilgisiForm from "@/components/forms/TasinmazBilgisiForm.vue";
import Dates from "@/components/inputs/Dates.vue";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import Tutar from "@/components/inputs/Tutar.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import AsilAlacakKalemiForm from "@/components/forms/alacak-kalemi/AsilAlacakKalemiForm.vue";
import AyEkleForm from "@/components/forms/AyEkleForm.vue";
import {TakipTipi} from "@/enum/TakipTipi";
import ProtestoIhtarForm from "@/components/forms/ProtestoIhtarForm.vue";
import {AbstractFormWizard} from "@/abstract_classes/AbstractFormWizard";
import {ParaBirimiEntity} from "@/entity/ParaBirimiEntity";
import StepperValidationForm from "@/components/StepperValidationForm.vue";
import {TakipAltTipiEntity} from "@/entity/TakipAltTipiEntity";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import Kur from "@/components/inputs/Kur.vue";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import {PopUpTitle} from "@/enum/PopUpTitle";
import PopUp from "@/components/dialogs/PopUp.vue";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import { takipteBsmvAlaniniGoster, takipteKdvAlaniniGoster } from "@/helpers/TakipTipiEskiNoHelper";


@Component({
  components: {
    PopUp,
    DovizTakipSekliPicker,
    Kur,
    StepperValidationForm,
    ProtestoIhtarForm,
    ParaBirimiPicker,
    TasinirBilgisiForm,
    TasinmazBilgisiForm,
    Tutar,
    Dates,
    ProtestoIhtar,
    IlamBilgileriForm,
    ItemArrayManager,
    AsilAlacakKalemiForm,
    AyEkleForm,
  },
})
export default class DigerAlacakFormWizard extends AbstractFormWizard {
  @Prop() takipTipiId!: number;
  @Prop({required: false}) takipTipiEskiNo?: string | number;
  @Prop() takipTalebi !: TakipTalebiEntity;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;

  action = ""
  PopUpTitle = PopUpTitle;
  activeStep = 1;
  TakipTipi = TakipTipi;
  get bsmvAlaniniGoster(): boolean {
    return takipteBsmvAlaniniGoster(this.takipTipiEskiNo);
  }
  get kdvAlaniniGoster(): boolean {
    return takipteKdvAlaniniGoster(this.takipTipiEskiNo);
  }
  paraBirimi = ParaBirimi;
  dovizTakipSekli = DovizTakipSekli;
  dialog = false;

  stepperHeaders = [
    "Diğer Alacak",
    "İhtar"
  ];
  defaultMahkeme = {
    ilam: 1,
    yargiBirimi: 13,
    dosya: 1
  }
  @Watch('activeStep')
  changeStep(){
    if(this.activeStep === 3) {
      this.action ="/api/v1/faiz-turu/filter?aktif_mi=1"
    }
  }

  @Watch('localValue.ihtar_var_mi')
  onIhtarVarMiChange() {
    if (this.localValue.ihtar_var_mi && !this.localValue.ihtarlar) {
      this.localValue.ihtarlar = [];
    } else {
      delete this.localValue.ihtarlar;
    }
  }

  onParaBirimiChange() {
    if (this.localValue.para_birimi_id == this.paraBirimi.TRY)
      delete this.localValue.doviz_kur_tarihi;
    this.input();
  }

  vadeCheck() {
    this.dialog = true;
  }

  stepCheck() {
    this.dialog = false;
    this.nextStep();
  }

  mounted() {
    this.$emit('hide-button', true);
    if (this.takipTipiId == TakipTipi.ipotekIcraEmri || this.takipTipiId == TakipTipi.ipotekOdemeEmri || this.takipTipiId == TakipTipi.menkulRehni) {
      this.stepperHeaders.push("Taşınır/ Taşınmaz Bilgisi");
      this.stepperHeaders.push("Alacak Kalemi");
    } else {
      this.stepperHeaders.push("Alacak Kalemi");
    }
    if (this.takipTipiId === TakipTipi.menkulTeslimi) this.stepperHeaders.splice(-1, 1);
    if (!this.localValue.asil_alacaklar && this.takipTipiId !== TakipTipi.menkulTeslimi) {
      this.localValue.asil_alacaklar = [];
    }
    if (!this.localValue.tasinmazlar && (this.takipTipiId == TakipTipi.ipotekIcraEmri || this.takipTipiId == TakipTipi.ipotekOdemeEmri)) {
      this.localValue.tasinmazlar = [];
    } else if (!this.localValue.tasinmazlar && this.takipTipiId == TakipTipi.menkulRehni) {
      this.localValue.tasinirlar = [];
    }
  }
}
